<!--
 * @Author       : 周家正
 * @Date         : 2021-07-14 17:34:50
 * @LastEditors  : yangjinbiao
 * @LastEditTime : 2021-08-10 15:42:46
 * @Description  : 缺省页
-->
<template>
  <div
    id="publicBlank"
    class="publicBlank"
  >
    <img
      src="@/assets/images/app/nothingmore.png"
      alt=""
    />
    <p>{{ textString }}</p>
  </div>
</template>

<script>
export default {
  name: 'publicBlank',
  props: {
    textString: { String, default: '更多产品敬请期待' },
  },
}
</script>
<style scoped lang="less">
img {
  display: block;
  width: 300px;
  height: 149px;
  margin: 142px auto 24px;
}
p {
  opacity: 1;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #9f9f9f;
  line-height: 20px;
}
</style>
